var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Wave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 470,
    viewBox: "0 0 1440 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 135.521L30 114.617C60 93.7117 120 51.9018 180 41.8098C240 31.7178 300 51.9018 360 67.7607C420 83.6196 480 93.7117 540 114.617C600 135.521 660 166.518 720 135.521C780 103.804 840 10.8129 900 5.76687C960 0 1020 83.6196 1080 83.6196C1140 83.6196 1200 0 1260 0C1320 0 1380 83.6196 1410 124.709L1440 166.518V470H1410C1380 470 1320 470 1260 470C1200 470 1140 470 1080 470C1020 470 960 470 900 470C840 470 780 470 720 470C660 470 600 470 540 470C480 470 420 470 360 470C300 470 240 470 180 470C120 470 60 470 30 470H0V135.521Z",
    fill: "url(#paint0_linear_611_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_611_7",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004958"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Wave);
export default __webpack_public_path__ + "static/media/3wave.68a33d450ee2253b44ef402442f6df99.svg";
export { ForwardRef as ReactComponent };